import { CurrentUserState } from './CurrentUserState';
import { TrialLessonConfigState } from './TrialLessonConfigState';

export const GlobalStates = {
  currentUser: new CurrentUserState(),
  lessonConfig: new TrialLessonConfigState(),
};
